function awInitReveals() {
  const els = document.querySelectorAll('.aw-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach((el) => el.classList.add('aw-visible'));
    return;
  }
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('aw-visible');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach((el) => io.observe(el));
}

function awInitContador() {
  const els = document.querySelectorAll('[data-aw-contador]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) return;
  const anima = (el) => {
    const fin = parseFloat(el.dataset.awContador || '0');
    const dur = 1400;
    const inicio = performance.now();
    const paso = (ahora) => {
      const t = Math.min(1, (ahora - inicio) / dur);
      const val = fin * (1 - Math.pow(1 - t, 3));
      el.textContent = fin % 1 === 0 ? Math.round(val).toString() : val.toFixed(1);
      if (t < 1) requestAnimationFrame(paso);
    };
    requestAnimationFrame(paso);
  };
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          anima(entry.target);
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.5 }
  );
  els.forEach((el) => io.observe(el));
}

function awInitAcordeon() {
  const grupos = document.querySelectorAll('[data-aw-faq]');
  grupos.forEach((grupo) => {
    const items = grupo.querySelectorAll('[data-aw-faq-item]');
    items.forEach((item) => {
      const btn = item.querySelector('[data-aw-faq-pregunta]');
      if (!btn) return;
      btn.addEventListener('click', () => {
        const abierto = item.classList.contains('aw-faq-abierto');
        items.forEach((i) => i.classList.remove('aw-faq-abierto'));
        if (!abierto) item.classList.add('aw-faq-abierto');
      });
    });
  });
}

function awInitColores() {
  const grupos = document.querySelectorAll('[data-aw-colores]');
  grupos.forEach((grupo) => {
    const botones = grupo.querySelectorAll('[data-aw-color-btn]');
    const imagenes = grupo.querySelectorAll('[data-aw-color-img]');
    botones.forEach((btn) => {
      btn.addEventListener('click', () => {
        const color = btn.dataset.awColorBtn;
        botones.forEach((b) => b.classList.remove('aw-color-activo'));
        btn.classList.add('aw-color-activo');
        imagenes.forEach((img) => {
          img.classList.toggle('aw-visible-color', img.dataset.awColorImg === color);
        });
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  awInitReveals();
  awInitContador();
  awInitAcordeon();
  awInitColores();
});
